import { RootState } from '@reducers';

export const selectToastProvider = (state: RootState) => state.ToastProviderReducer;
